/* MYA theme — interactions only.
   Prodotti, Instagram e FAQ sono renderizzati da Liquid lato server.
   Qui gestiamo solo: accordion FAQ, drawer mobile, scroll reveal. */

/* FAQ accordion (delegato: funziona con markup generato da Liquid) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.faq__q');
  if (!btn) return;
  var item = btn.parentElement;
  var ans = btn.nextElementSibling;
  var list = item.parentElement;
  var isOpen = item.classList.contains('open');

  list.querySelectorAll('.faq__item').forEach(function (it) {
    it.classList.remove('open');
    var q = it.querySelector('.faq__q');
    var a = it.querySelector('.faq__a');
    if (q) q.setAttribute('aria-expanded', 'false');
    if (a) a.style.maxHeight = null;
  });

  if (!isOpen) {
    item.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    ans.style.maxHeight = ans.scrollHeight + 'px';
  }
});

/* Mobile drawer */
(function () {
  var burger = document.getElementById('burgerBtn');
  var drawer = document.getElementById('drawer');
  if (!burger || !drawer) return;
  var closeBtn = document.getElementById('drawerClose');

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function (e) {
    e.stopPropagation();
    drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeDrawer);
  });

  // chiudi cliccando sullo sfondo (fuori dal contenuto)
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) closeDrawer();
  });

  // chiudi con tasto ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });
})();

/* Scroll reveal — progressive enhancement */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduce) return;
  var els = document.querySelectorAll('.section-title, .card, .cat, .statement__line, .review, .usp__item');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.style.opacity = '1';
        en.target.style.transform = 'none';
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(26px)';
    el.style.transition = 'opacity .8s cubic-bezier(.6,.01,.05,.95), transform .8s cubic-bezier(.6,.01,.05,.95)';
    io.observe(el);
  });
  setTimeout(function () {
    els.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
  }, 2500);
})();

/* ============================================
   COUNTDOWN offerta prodotto
   Gestisce tutti gli elementi [data-countdown] in pagina.
   ============================================ */
(function () {
  var nodes = document.querySelectorAll('[data-countdown]');
  if (!nodes.length) return;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var now = Date.now();
    nodes.forEach(function (el) {
      if (el.dataset.done === '1') return;
      var end = new Date(el.dataset.end).getTime();
      var diff = end - now;

      if (isNaN(end)) { el.style.display = 'none'; return; }

      if (diff <= 0) {
        el.dataset.done = '1';
        el.classList.add('countdown--expired');
        el.innerHTML = '<span class="countdown__expired">' + (el.dataset.expiredText || 'Offerta scaduta') + '</span>';
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var dEl = el.querySelector('[data-d]');
      var hEl = el.querySelector('[data-h]');
      var mEl = el.querySelector('[data-m]');
      var sEl = el.querySelector('[data-s]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    });
  }

  tick();
  setInterval(tick, 1000);
})();

/* ============================================
   SOCIAL PROOF & CONVERSIONI
   ============================================ */
(function () {
  function randInt(min, max) {
    min = parseInt(min, 10) || 0; max = parseInt(max, 10) || 0;
    if (max < min) max = min;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function fill(tpl, map) {
    return (tpl || '').replace(/\[(\w+|nome|città|citta|prodotto)\]/g, function (_, k) {
      return map[k] != null ? map[k] : '';
    });
  }

  /* Stock basso */
  document.querySelectorAll('[data-sp-stock]').forEach(function (el) {
    var n;
    if (el.dataset.mode === 'real') {
      n = parseInt(el.dataset.qty, 10) || 0;
    } else {
      n = randInt(el.dataset.min, el.dataset.max);
    }
    el.querySelector('.sp__text').textContent = fill(el.dataset.template, { n: n });
  });

  /* Persone che guardano — numero che oscilla leggermente */
  document.querySelectorAll('[data-sp-viewers]').forEach(function (el) {
    var txt = el.querySelector('.sp__text');
    function set() {
      txt.textContent = fill(el.dataset.template, { n: randInt(el.dataset.min, el.dataset.max) });
    }
    set();
    setInterval(set, randInt(8000, 15000));
  });

  /* Acquisti recenti */
  document.querySelectorAll('[data-sp-recent]').forEach(function (el) {
    el.querySelector('.sp__text').textContent = fill(el.dataset.template, {
      n: randInt(el.dataset.min, el.dataset.max),
      t: el.dataset.minutes
    });
  });

  /* Notifiche popup */
  var popupRoot = document.querySelector('[data-sp-popup]');
  if (popupRoot) {
    var names = (popupRoot.dataset.names || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var cities = (popupRoot.dataset.cities || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var products = (popupRoot.dataset.products || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    var tpl = popupRoot.dataset.template;
    var interval = (parseInt(popupRoot.dataset.interval, 10) || 9) * 1000;
    var duration = (parseInt(popupRoot.dataset.duration, 10) || 5) * 1000;

    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }

    function showOne() {
      if (!names.length) return;
      var mins = randInt(2, 40);
      var box = document.createElement('div');
      box.className = 'sp-popup';
      box.innerHTML =
        '<span class="sp-popup__avatar">' + (pick(names)[0] || '•') + '</span>' +
        '<div class="sp-popup__body"><p class="sp-popup__main">' +
        fill(tpl, { 'nome': pick(names), 'città': pick(cities), 'citta': pick(cities), 'prodotto': products.length ? pick(products) : '' }) +
        '</p><p class="sp-popup__time">' + mins + ' minuti fa</p></div>';
      popupRoot.appendChild(box);
      requestAnimationFrame(function () { box.classList.add('show'); });
      setTimeout(function () {
        box.classList.remove('show');
        setTimeout(function () { box.remove(); }, 500);
      }, duration);
    }

    setTimeout(function () {
      showOne();
      setInterval(showOne, interval);
    }, 3000);
  }

  /* Bundle — aggiungi il set al carrello */
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var btn = bundle.querySelector('[data-bundle-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = [];
      bundle.querySelectorAll('[data-bundle-item]').forEach(function (it) {
        if (it.dataset.on === '1' && it.dataset.id) items.push({ id: parseInt(it.dataset.id, 10), quantity: 1 });
      });
      if (!items.length) return;
      btn.disabled = true; btn.textContent = 'Aggiunta...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Riprova'; });
    });
  });
})();
